import { DEFAULT_ARDOQ_I18NLOCALE, type I18nLocale } from '@ardoq/i18n';
import { returnPayload } from '@ardoq/common-helpers';
import {
  actionCreator,
  persistentReducedStream,
  reducer,
} from '@ardoq/rxbeach';
import { DEFAULT_LANGUAGE } from '../supportedLanguages';

export const setTranslationBundle = actionCreator<I18nLocale>(
  '[i18n] set translation bundle'
);

/**
 * Used to push the parent window's locale into a popout/iframe build target
 * (such as the perspective editor) over the postMessageBridge. The popout has
 * no current-user stream of its own, so it cannot derive the language via
 * `translationSyncRoutine`. The parent serialises just the BCP47 language tag
 * into this action; `handleSetI18nLocaleRoutine` switches `@ardoq/i18n` to the
 * matching language and then pushes the bundle from its local `LOCALE_BUNDLES`
 * into `i18nLocale$`.
 */
export const setI18nLocale = actionCreator<{ language: string }>(
  '[i18n] set locale (bridge)'
);

export const setI18nLanguage = actionCreator<string>('[i18n] set language');

export const i18nLocale$ = persistentReducedStream<I18nLocale>(
  'i18nLocale$',
  DEFAULT_ARDOQ_I18NLOCALE,
  [reducer(setTranslationBundle, returnPayload)]
);

/**
 * Stream of the current BCP-47 language tag (e.g. `'en'`, `'de'`). Emits in
 * lockstep with `i18nLocale$`. Use this to feed `Intl.DateTimeFormat` /
 * `Intl.NumberFormat` and similar APIs that need a language tag rather than
 * a translation bundle.
 */
export const i18nLanguage$ = persistentReducedStream<string>(
  'i18nLanguage$',
  DEFAULT_LANGUAGE,
  [reducer(setI18nLanguage, returnPayload)]
);
